<template>
  <v-container fluid class="pa-8">
    <v-text-field
      v-model="search"
      label="Buscar faixa etária..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dark
      class="search-bar mb-6 custom-input"
      @input="list()"
      clearable
    ></v-text-field>

    <v-btn class="my-5 zinnes-primary-btn" dark @click="novo()">
      Nova Faixa Etária
    </v-btn>

    <v-simple-table class="custom-table">
      <thead>
        <tr>
          <th class="text-left">Id</th>
          <th class="text-left">Faixa</th>
          <th class="text-left">Descrição</th>
          <th class="text-left">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="ageRating in ageRatings"
          :key="ageRating.id"
          style="height: 70px; font-size: 16px;"
        >
          <td>{{ ageRating.id }}</td>
          <td>
            <v-chip small :color="ratingColor(ageRating.age)" :dark="ageRating.age !== 12" :light="ageRating.age === 12">
              {{ ageRating.rating }}
            </v-chip>
          </td>
          <td>{{ ageRating.description }}</td>
          <td>
            <v-btn icon @click="select(ageRating)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <div class="text-center">
      <v-pagination
        color="var(--zinnes-primary)"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        total-visible="5"
        @input="list"
      ></v-pagination>
    </div>

    <ModalAgeRating ref="modal" :list="list"></ModalAgeRating>
  </v-container>
</template>

<script>
import UtilMixins from '@/mixins/UtilMixins';
import AgeRatingService from '@/server/AgeRatingService';
import ModalAgeRating from './ModalAgeRating.vue';

export default {
  mixins: [UtilMixins],
  components: { ModalAgeRating },
  data: () => ({
    service: new AgeRatingService(),
    search: '',
  }),
  computed: {
    ageRatings: {
      get()     { return this.$store.getters['getAgeRatings']; },
      set(dado) { this.$store.dispatch('setAgeRatings', dado); },
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    list(page = 1) {
      const params = {
        page,
        description: this.search,
      };
      this.service.list(params)
        .then(res => {
          this.ageRatings = res.data;
          this.paginate    = res;
        });
    },
    novo() {
      this.$refs.modal.abrirModal();
    },
    select(data) {
      this.$store.dispatch('setAgeRating', data);
      this.$refs.modal.abrirModal();
    },
    ratingColor(age) {
      if (age <= 10) return '#0095DA';
      if (age <= 12) return '#FBC115';
      if (age <= 14) return '#F58220';
      return '#EC1D25';
    },
  },
};
</script>
